var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"main-header"},[_c('div',[_c('span',{staticStyle:{"color":"white"}},[_vm._v("Covid-19 Tracker!")])])])}]

export { render, staticRenderFns }